import { render } from "./ActionsPage.vue?vue&type=template&id=6f35a25e&ts=true"
import script from "./ActionsPage.vue?vue&type=script&lang=ts"
export * from "./ActionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__